export const themeData = [
  {
    title: "More than Meta",
    desc: "Providing decentralised solutions for real world problems.",
  },
  {
    title: "More than Metros",
    desc: "Solving city planning woes with the concept of Smart Cities.",
  },
  {
    title: "More than Media",
    desc: "Combating misinformation and Disinformation",
  },
  {
    title: "More than Cosmos",
    desc: "Innovation in space science & technology",
  },
  {
    title: "Sustainable development goals",
    desc: "Encouraging innovative solutions for a better planet",
  },
  {
    title: "Pandora",
    desc: " Let your curiosity take over, Open innovation",
  },
];
